export const roomStatus = {
  none: {
    sortOrder: 1,
    statusText: 'Ready',
  },
  started: {
    sortOrder: 2,
    statusText: 'Test in progress',
  },
  ended: {
    sortOrder: 3,
    statusText: 'Test ended',
  },
};

export const roomOptions = {
  'Ready': 'Ready',
  'Test ended': 'Test ended',
  'Test in progress': 'Test in progress',
};

export const roomAssignmentStatus = {
  assigned: 'Students assigned',
  full: 'Full',
  unassigned: 'Unassigned',
};

export const previewRoom = '757a0b28-14ad-492d-bad6-35e02fc9e9c1';
